var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0.886
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6 L7,6 L7,4.5 C7,3.67157288 7.67157288,3 8.5,3 L15.5,3 C16.3284271,3 17,3.67157288 17,4.5 L17,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,19 C22,19.5522847 21.5522847,20 21,20 L3,20 C2.44771525,20 2,19.5522847 2,19 L2,7 C2,6.44771525 2.44771525,6 3,6 Z M8,4.5 L8,6 L16,6 L16,4.5 C16,4.22385763 15.7761424,4 15.5,4 L8.5,4 C8.22385763,4 8,4.22385763 8,4.5 Z M3,7 L3,11 L10,11 L10,12.5 C10,12.7761424 10.2238576,13 10.5,13 L13.5,13 C13.7761424,13 14,12.7761424 14,12.5 L14,11 L21,11 L21,7 L3,7 Z M3,12 L3,19 L21,19 L21,12 L15,12 L15,12.5 C15,13.3284271 14.3284271,14 13.5,14 L10.5,14 C9.67157288,14 9,13.3284271 9,12.5 L9,12 L3,12 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.c51340deff16e2f6ef97c2d672c39fcf.svg";
export { ForwardRef as ReactComponent };